import { useCallback, useEffect, useState } from 'react'
import { useField } from 'formik'
import { ISalesTeam } from '@user/store/salesTeam'

interface Props {
  onUpdate: (s: number, o: string | null, r: boolean) => void
}

export function useActions(props: Props) {
  const { onUpdate } = props
  const [disableSave, setDisableSave] = useState<boolean>(true)
  const [removeServices, setRemoveServices] = useState<boolean>(false)
  const [, teamMeta, teamHelpers] = useField('teamId')
  const { value: teamId, touched: teamTouched } = teamMeta
  const { setValue: setTeamId } = teamHelpers
  const [, ownerMeta, ownerHelpers] = useField('ownerId')
  const { value: ownerId, error: ownerError, touched } = ownerMeta

  const { setValue: setOwner } = ownerHelpers

  useEffect(() => {
    if (touched) setDisableSave(Boolean(ownerError))
  }, [setDisableSave, touched, ownerError])

  const onSave = useCallback(() => {
    if (!disableSave && teamId > 0) {
      onUpdate(
        teamId,
        ownerId === 'unassigned' ? null : ownerId,
        removeServices,
      )
      setDisableSave(true)
    }
  }, [onUpdate, disableSave, teamId, ownerId, removeServices])

  const onTeamChange = useCallback(
    (value: ISalesTeam | null) => {
      if (value) {
        setTeamId(+value.id)
        setOwner('unassigned')
        setDisableSave(teamTouched)
      }
      if (!value) {
        setTeamId('')
        setOwner('')
        setDisableSave(true)
      }
    },
    [setOwner, setTeamId, teamTouched],
  )

  const onRemoveServicesChange = useCallback(
    (checked: boolean) => {
      setRemoveServices(checked)
      setTeamId('')
      setOwner('')
      setDisableSave(true)
    },
    [setRemoveServices, setTeamId, setOwner],
  )

  return {
    onSave,
    onTeamChange,
    disableSave,
    setDisableSave,
    onRemoveServicesChange,
    removeServices,
  }
}
